export default __webpack_public_path__ + "static/media/speedometer.b5efc93c.svg";